<template>
    <div class="query-container">
        <!-- 顶部标题栏 -->
        <div class="header">
            <div class="logo">
                <span class="logo-text">移动网络接入认证</span>
            </div>
            <div class="query-title">设备号查询</div>
        </div>

        <!-- 主要内容区域 -->
        <div class="query-content">
            <div class="query-card">
                <h2 class="card-title">设备号信息查询</h2>

                <div class="tips">
                    <i class="el-icon-info"></i>
                    请输入您的设备号，查询信息后即可进行认证
                </div>

                <el-form :model="form" :rules="rules" ref="formRef">
                    <!-- ICCID输入 -->
                    <div class="form-item">
                        <label class="form-label">设备号</label>
                        <el-form-item prop="iccid">
                            <el-input
                                    v-model="form.iccid"
                                    placeholder="请输入设备号"
                                    maxlength="20"
                                    clearable
                                    @keyup.enter="queryIccid"
                                    size="large">
                                <i slot="prefix" class="el-icon-credit-card"></i>
                            </el-input>
                        </el-form-item>
                        <div class="input-hint">
                            <i class="el-icon-info"></i>
                            设备号，位于设备或包装盒标签上。
                        </div>
                    </div>

                    <!-- 查询按钮 -->
                    <el-button
                            type="primary"
                            class="query-btn"
                            :loading="queryLoading"
                            @click="queryIccid">
                        <i class="el-icon-search"></i>
                        查询设备号
                    </el-button>
                </el-form>
            </div>
        </div>
        <!-- 底部信息 -->
        <div class="footer">
            <p>© 2026 网络服务提供商 版权所有</p>
        </div>
    </div>
</template>

<script>
    import {oneLinkAuthCardInfo} from '../api/oneLinkAuth'


    export default {
        name: 'queryIccid',
        data() {
            const validateIccid = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入设备号'));
                }else {
                    callback();
                }
            };

            return {
                form: {
                    iccid: null
                },
                rules: {
                    iccid: [{ validator: validateIccid, trigger: 'blur' }]
                },
                queryLoading: false,
                queryResult: null,
                historyList: []
            }
        },

        created() {

        },

        methods: {
            // 查询ICCID信息
            queryIccid: function() {
                var that = this

                this.$refs.formRef.validate(function(valid) {
                    if (valid) {
                        that.queryLoading = true
                        oneLinkAuthCardInfo(that.form.iccid)
                            .then(function(res) {
                                if (res.data && (res.data.code === '0' || res.data.code === 0)) {
                                    that.queryResult = res.data.data
                                    that.goToAuth()
                                    that.$message.success('查询成功')
                                } else {
                                    that.$message.error(res.data.message || '设备号无效')
                                    that.queryResult = null
                                }
                                that.queryLoading = false
                            })
                            .catch(function(error) {
                                console.error('查询失败', error)
                                that.queryLoading = false
                                that.queryResult = null
                                that.$message.error('查询失败，请稍后重试')
                            })
                    }
                })
            },
            // 跳转到认证页面
            goToAuth() {
                // 将查询到的ICCID信息传递给认证页面
                this.$router.push({
                    name: 'auth',
                    query: {
                        iccid: this.queryResult.iccid,
                        imei: this.queryResult.imei,
                        mac: this.queryResult.mac,
                        terminalMac: this.queryResult.terminalMac
                    }
                });
            }
        }
    }
</script>

<style scoped>
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    /* 移动端全局适配 */
    html, body {
        font-size: 16px; /* 防止移动端自动缩放 */
    }

    .query-container {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        position: relative;
    }

    .header {
        padding: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
        background: rgba(0, 0, 0, 0.2);
    }

    .logo-text {
        font-size: 18px;
        font-weight: 500;
    }

    .query-title {
        font-size: 16px;
        font-weight: 500;
    }

    .query-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        min-height: calc(100vh - 120px); /* 确保内容区域高度足够 */
    }

    .query-card {
        width: 100%;
        max-width: 500px;
        background: white;
        border-radius: 20px;
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        padding: 40px 30px;
        margin: 0 auto; /* 居中 */
        transition: all 0.3s ease;
    }

    /* 移动端卡片内边距优化 */
    @media (max-width: 480px) {
        .query-card {
            padding: 30px 24px;
        }
        .card-title {
            font-size: 22px;
            margin-bottom: 16px;
        }
    }

    .card-title {
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 24px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .tips {
        background: #f0f7ff;
        border-radius: 12px;
        padding: 14px 18px;
        margin-bottom: 32px;
        font-size: 14px;
        color: #409eff;
        border-left: 4px solid #409eff;
        display: flex;
        align-items: center;
        line-height: 1.4;
    }

    .tips i {
        margin-right: 10px;
        font-size: 18px;
        flex-shrink: 0;
    }

    .form-item {
        margin-bottom: 32px;
    }

    .form-label {
        display: block;
        margin-bottom: 12px;
        font-size: 16px;
        color: #333;
        font-weight: 600;
    }

    /* 移动端输入框放大优化 */
    .form-item >>> .el-input {
        font-size: 16px !important; /* 防止输入框字体自动缩放 */
    }

    .form-item >>> .el-input__inner {
        height: 52px !important;
        line-height: 52px !important;
        font-size: 18px !important;
        padding: 0 40px 0 40px !important;
        border-radius: 12px !important;
        border: 1px solid #e0e4e8 !important;
        transition: all 0.3s ease;
    }

    .form-item >>> .el-input__inner:focus {
        border-color: #667eea !important;
        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
    }

    /* 输入框前缀图标放大 */
    .form-item >>> .el-input__prefix {
        left: 16px !important;
        font-size: 20px !important;
    }

    .form-item >>> .el-input__prefix i {
        font-size: 20px !important;
        line-height: 52px !important;
    }

    .input-hint {
        margin-top: 12px;
        font-size: 13px;
        color: #999;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .input-hint i {
        font-size: 14px;
    }

    /* 移动端按钮放大优化 */
    .query-btn {
        width: 100%;
        height: 56px !important;
        font-size: 18px !important;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 0;
        border-radius: 28px !important;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;
        transition: transform 0.2s, box-shadow 0.2s;
    }

    .query-btn:active {
        transform: scale(0.98);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }

    /* 移动端表单校验错误信息优化 */
    .form-item >>> .el-form-item__error {
        font-size: 13px;
        padding-top: 6px;
    }

    .query-result {
        margin-top: 30px;
        border: 1px solid #e8eaed;
        border-radius: 16px;
        overflow: hidden;
        animation: slideIn 0.3s ease-out;
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .result-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        padding: 15px 20px;
        font-weight: 600;
        display: flex;
        align-items: center;
        font-size: 16px;
    }

    .result-header i {
        font-size: 20px;
        margin-right: 10px;
    }

    .result-content {
        padding: 24px;
        background: #fafafa;
    }

    .result-item {
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .result-item .label {
        font-size: 14px;
        color: #666;
        min-width: 100px;
    }

    .result-item .value {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        word-break: break-all;
    }

    .result-item .value.highlight {
        color: #409eff;
        font-size: 16px;
    }

    .result-item .value.premium {
        color: #f56c6c;
        font-weight: 600;
    }

    .copy-btn {
        margin-left: 12px;
        padding: 0;
    }

    .result-footer {
        padding: 18px 24px;
        background: white;
        border-top: 1px solid #e8eaed;
    }

    .auth-btn {
        width: 100%;
        height: 48px;
        font-size: 16px;
    }

    .history-section {
        margin-top: 30px;
        border-top: 1px solid #e8eaed;
        padding-top: 24px;
    }

    .history-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        font-size: 14px;
        color: #666;
    }

    .history-header i {
        margin-right: 8px;
    }

    .history-list {
        max-height: 250px;
        overflow-y: auto;
    }

    .history-item {
        padding: 14px;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.2s;
        border: 1px solid #f0f0f0;
        margin-bottom: 10px;
    }

    .history-item:hover {
        background: #f5f7fa;
        transform: translateX(5px);
    }

    .history-iccid {
        font-size: 14px;
        font-weight: 600;
        color: #333;
        margin-bottom: 6px;
        font-family: monospace;
        word-break: break-all;
    }

    .history-info {
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #999;
    }

    .history-time {
        font-size: 11px;
    }

    .footer {
        padding: 20px;
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        font-size: 12px;
    }

    /* 移动端小屏进一步优化 */
    @media (max-width: 380px) {
        .query-card {
            padding: 24px 18px;
        }

        .form-item >>> .el-input__inner {
            height: 48px !important;
            line-height: 48px !important;
            font-size: 16px !important;
        }

        .query-btn {
            height: 50px !important;
            font-size: 16px !important;
        }

        .result-item {
            flex-direction: column;
            align-items: flex-start;
        }

        .result-item .label {
            margin-bottom: 6px;
        }
    }

    /* 大屏手机/平板上保持卡片居中且不太宽 */
    @media (min-width: 768px) {
        .query-card {
            max-width: 550px;
            padding: 45px 40px;
        }

        .form-item >>> .el-input__inner {
            height: 56px !important;
            line-height: 56px !important;
        }
    }

    /* 移除el-input的默认边框高亮效果，使用自定义样式 */
    .form-item >>> .el-input__inner:focus {
        outline: none;
    }

    /* 确保卡片内容垂直居中 */
    .query-content {
        justify-content: center;
    }
</style>